const formatTime = require('../../../../utils/formatTime');
const getDateRange = require('./getDateRange');

module.exports = (self, params) => {
  const filter = self.state.filter;
  const {from, to} = getDateRange(filter);
  const {min_amount, max_amount} = filter;
  const {disableDateConversion} = (params || {});

  const dateMask = '{yyyy}-{mm}-{dd}';

  const result = {
    search: filter.search || null,
    from: from
      ? disableDateConversion
        ? from
        : formatTime(from, dateMask)
      : null,
    to: to
      ? disableDateConversion
        ? to
        : formatTime(to, dateMask)
      : null,
  };

  const rangeHasError = min_amount && max_amount && Number(min_amount) > Number(max_amount);
  const addEurFlag = (min_amount || max_amount) && !rangeHasError;

  if (min_amount && !rangeHasError) result['min_amount'] = min_amount;
  if (max_amount && !rangeHasError) result['max_amount'] = max_amount;
  if (addEurFlag) result['use_eur_amount'] = true;

  return result;
};
